export default __webpack_public_path__ + "dd09149f482ca01f9b46699f676df307.png";